import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "../auth/msalConfig";
import { appConfig } from "../../lib/config/appConfig";

export function LoginPage() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">IG</div>
        <h1 className="login-title">{appConfig.appName}</h1>
        <p className="login-subtitle">Sign in with your Intal Garments account to continue.</p>
        <button className="login-button" onClick={handleLogin}>
          Sign in with Microsoft
        </button>
        <div className="login-footer">v{appConfig.appVersion}</div>
      </div>
    </div>
  );
}
